import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-container-bill-of-lading',
  templateUrl: './container-bill-of-lading.component.html',
  styleUrls: ['./container-bill-of-lading.component.css']
})
export class ContainerBillOfLadingComponent implements OnInit {
  labelbtnadditems='Add'
  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  idEditItems=0
  arrayItems=[];
  viewites=false;
  idEdit=0
  formItems:FormGroup;
formBillofLading:FormGroup;
  constructor(private authenticationService:AuthenticationService,private _httpClient:HttpClient,
    private formbuilder:FormBuilder,
    public dialogRef: MatDialogRef<ContainerBillOfLadingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

this.arrayItems=[];

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
this.idEdit=this.data.tipo

this.formItems=this.formbuilder.group({
hm:[""],
Description:[""],
Weight:[""],
Class:[""],
Charges:[""],
type_unit:[" "],
quantity:[""]


})

this.formBillofLading=this.formbuilder.group({
  From:[""],
  FromStreet:[""],
  To:[""],
  ToStreet:[""],
  Bill:[""],
  BillStreet:[""],
  ShipperNumber:[""],
  DateHeader:[""],
  Route:[""],
  VehicleNumber:[""],
  Amt:[""],
  codfee:[""],
  prepaidCollect:[""],
  totalCharges:[""],
  shipper:[""],
  perShipper:[""],
  carrier:[""],
  perCarrier:[""],
  dateCaarrier:[""],
  SpecialInstructions:[""],
  ConsigneeContact:[""],
  signed:[""],
  unitReceived:[""],
  shipperLoad:[""],
  consigneunload:[""],
  dateconsigne:[""],
  pro:[""],
  fromorigin:[""],
  todestination:[""]



})
try {
  if(this.idEdit==0){

    if(this.authenticationService.currentUserValue.company=='LDT20'){
      this.formBillofLading.controls.From.setValue('PENTAIR C/O LINE DRIVE TRUCKING');
      this.formBillofLading.controls.FromStreet.setValue('1231 N. MILLER ST. STE #150');
      this.formBillofLading.controls.fromorigin.setValue('ANAHEIM, CA. 92806');
      this.formBillofLading.controls.To.setValue('PENTAIR WATER POOL & SPA');
      this.formBillofLading.controls.ToStreet.setValue('13950 MOUNTAIN AVE.');
      this.formBillofLading.controls.todestination.setValue('CHINO, CA. 91710');
     this.formBillofLading.controls.Bill.setValue('PENTAIR WATER C/O RATELINX');
      this.formBillofLading.controls.BillStreet.setValue('P.O. BOX 77065 MADISON, WISCONSIN 53707');
      this.formBillofLading.controls.carrier.setValue('Line Drive Trucking');
    }


this.viewites=false;
  }else{
    this.onSelectItems(this.idEdit)
    this.onEditBillOfLading();
    this.viewites=true;
  }
} catch (error) {
  
}
  }

OnsaveBillofLading(){
console.log(this.formBillofLading.value);
var js={
  "tipo": Number(this.idEdit),
  "tblcontainerID": Number(this.data.idcontainer),
  "from": String(this.formBillofLading.controls.From.value||''),
  "fromStreet": String(this.formBillofLading.controls.FromStreet.value||''),
  "to": String(this.formBillofLading.controls.To.value||''),
  "toStreet": String(this.formBillofLading.controls.ToStreet.value||''),
  "bill": String(this.formBillofLading.controls.Bill.value||''),
  "billStreet": String(this.formBillofLading.controls.BillStreet.value||''),
  "shipperNumber": String(this.formBillofLading.controls.ShipperNumber.value||''),
  "dateHeader": String(this.formBillofLading.controls.DateHeader.value||''),
  "route": String(this.formBillofLading.controls.Route.value||''),
  "vehicleNumber": String(this.formBillofLading.controls.VehicleNumber.value||''),
  "amt": String(this.formBillofLading.controls.Amt.value||''),
  "codfee": String(this.formBillofLading.controls.codfee.value||''),
  "prepaidCollect": String(this.formBillofLading.controls.prepaidCollect.value||''),
  "totalCharges": String(this.formBillofLading.controls.totalCharges.value||''),
  "shipper": String(this.formBillofLading.controls.shipper.value||''),
  "perShipper": String(this.formBillofLading.controls.perShipper.value||''),
  "carrier": String(this.formBillofLading.controls.carrier.value||''),
  "perCarrier": String(this.formBillofLading.controls.perCarrier.value||''),
  "dateCaarrier": String(this.formBillofLading.controls.dateCaarrier.value||''),
  "specialInstructions": String(this.formBillofLading.controls.SpecialInstructions.value||''),
  "consigneeContact":String(this.formBillofLading.controls.ConsigneeContact.value||''),
  "signed": String(this.formBillofLading.controls.signed.value||''),
  "unitReceived":String(this.formBillofLading.controls.unitReceived.value||''),
  "shipperLoad": String(this.formBillofLading.controls.shipperLoad.value||''),
  "consigneunload": String(this.formBillofLading.controls.consigneunload.value||''),
  "dateconsigne":String(this.formBillofLading.controls.dateconsigne.value||''),
  "pro":String(this.formBillofLading.controls.pro.value||''),
  "fromorigin":String(this.formBillofLading.controls.fromorigin.value||''),
  "todestination":String(this.formBillofLading.controls.todestination.value||'')
}









this._httpClient
.post<any>(
  `${environment.apiUrl}/Containers/RequestBillofLAdingContainer`,
  js,
  {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': '*',
      Authorization:
        'Bearer ' + this.authenticationService.currentUserValue.token
    })
  }
)
.subscribe((response: any) => {

  var t=String(response.responses)

  try {
    if (t.includes('success-')) {
      this.idEdit=Number(t.replace('success-',''))
      this.Toast.fire({
        icon: 'success',
        title: 'successful'
      })
    } else {
      this.idEdit=Number(t.replace('update-',''))
      this.Toast.fire({
        icon: 'success',
        title: 'Update successful'
      })
    }
  } catch (error) {
    
  }
  try {
    if(this.idEdit==0){
  this.viewites=false;
    }else{
      this.viewites=true;
    }
  } catch (error) {
    
  }
})

}


OnAddItems(){
  var js={
    "tipo": Number(this.idEditItems),
    "tblcontainerbillID": Number(this.idEdit),
    "hm": String(this.formItems.controls.hm.value||''),
    "description": String(this.formItems.controls.Description.value||''),
    "weight": String(this.formItems.controls.Weight.value||''),
    "class": String(this.formItems.controls.Class.value||''),
    "charges": String(this.formItems.controls.Charges.value||''),
    "type_unit": String(this.formItems.controls.type_unit.value||' '),
    "quantity": String(this.formItems.controls.quantity.value||' ')
  }
  this._httpClient
.post<any>(
  `${environment.apiUrl}/Containers/RequestBillofLAdingContainerAddItems`,
  js,
  {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Methods': '*',
      Authorization:
        'Bearer ' + this.authenticationService.currentUserValue.token
    })
  }
)
.subscribe((response: any) => {
  this.formItems.reset();
  this.idEditItems=0
  this.labelbtnadditems='Add'
  this.onSelectItems(this.idEdit)
})
}

onSelectItems(idD:any){

  this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/containerbillofladingitemsselect?tblcontainerbillID=${idD}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arrayItems=response;
      })
}

OnEditItems(items:any){
this.idEditItems=items.id_items
this.formItems.controls.hm.setValue(items.hm)
this.formItems.controls.Description.setValue(items.Description)
this.formItems.controls.Weight.setValue(items.Weight)
this.formItems.controls.Class.setValue(items.Class)
this.formItems.controls.Charges.setValue(items.Charges)
this.formItems.controls.type_unit.setValue(items.type_unit)
this.formItems.controls.quantity.setValue(items.quantity)

this.labelbtnadditems='Update'
}

onSelectItemsDelete(idD:any){

  this._httpClient
      .get<any>(
        `${environment.apiUrl}/Containers/containerbillofladingitemsDelete?id=${idD}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.onSelectItems(this.idEdit)
      })
}


onEditBillOfLading(){
console.log(this.data)
 this.formBillofLading.controls.From.setValue(this.data.datar.From);
  this.formBillofLading.controls.FromStreet.setValue(this.data.datar.FromStreet);
  this.formBillofLading.controls.To.setValue(this.data.datar.To);
  this.formBillofLading.controls.ToStreet.setValue(this.data.datar.ToStreet);
 this.formBillofLading.controls.Bill.setValue(this.data.datar.Bill);
  this.formBillofLading.controls.BillStreet.setValue(this.data.datar.BillStreet);
  this.formBillofLading.controls.ShipperNumber.setValue(this.data.datar.ShipperNumber);
  this.formBillofLading.controls.DateHeader.setValue(this.data.datar.DateHeader);
  this.formBillofLading.controls.Route.setValue(this.data.datar.Route);
  this.formBillofLading.controls.VehicleNumber.setValue(this.data.datar.VehicleNumber);
  this.formBillofLading.controls.Amt.setValue(this.data.datar.Amt);
  this.formBillofLading.controls.codfee.setValue(this.data.datar.codfee);
  this.formBillofLading.controls.prepaidCollect.setValue(this.data.datar.prepaidCollect);
 this.formBillofLading.controls.totalCharges.setValue(this.data.datar.totalCharges);
  this.formBillofLading.controls.shipper.setValue(this.data.datar.shipper);
  this.formBillofLading.controls.perShipper.setValue(this.data.datar.perShipper);
  this.formBillofLading.controls.carrier.setValue(this.data.datar.carrier);
  this.formBillofLading.controls.perCarrier.setValue(this.data.datar.perCarrier);
  this.formBillofLading.controls.dateCaarrier.setValue(this.data.datar.dateCaarrier);
  this.formBillofLading.controls.SpecialInstructions.setValue(this.data.datar.SpecialInstructions);
  this.formBillofLading.controls.ConsigneeContact.setValue(this.data.datar.Route);
  this.formBillofLading.controls.signed.setValue(this.data.datar.signed);
  this.formBillofLading.controls.unitReceived.setValue(this.data.datar.unitReceived);
  this.formBillofLading.controls.shipperLoad.setValue(this.data.datar.shipperLoad);
  this.formBillofLading.controls.consigneunload.setValue(this.data.datar.consigneunload);
  this.formBillofLading.controls.dateconsigne.setValue(this.data.datar.dateconsigne);
  this.formBillofLading.controls.pro.setValue(this.data.datar.pronumber);
  this.formBillofLading.controls.fromorigin.setValue(this.data.datar.fromorigin);
  this.formBillofLading.controls.todestination.setValue(this.data.datar.todestination);
}

onCreateNew(){
  this.formBillofLading.reset();
  
  this.formItems.reset();
  this.arrayItems=[];
  this.viewites=false;
  this.idEdit=0;
  this.idEditItems=0;
  if(this.authenticationService.currentUserValue.company=='LDT20'){
    this.formBillofLading.controls.From.setValue('PENTAIR C/O LINE DRIVE TRUCKING');
    this.formBillofLading.controls.FromStreet.setValue('1231 N. MILLER ST. STE #150');
    this.formBillofLading.controls.fromorigin.setValue('ANAHEIM, CA. 92806');
    this.formBillofLading.controls.To.setValue('PENTAIR WATER POOL & SPA');
    this.formBillofLading.controls.ToStreet.setValue('13950 MOUNTAIN AVE.');
    this.formBillofLading.controls.todestination.setValue('CHINO, CA. 91710');
   this.formBillofLading.controls.Bill.setValue('PENTAIR WATER C/O RATELINX');
    this.formBillofLading.controls.BillStreet.setValue('P.O. BOX 77065 MADISON, WISCONSIN 53707');
    this.formBillofLading.controls.carrier.setValue('Line Drive Trucking');

  }
}
}
